import {
    DateFilter,
    WikiSearchAuthor,
    WikiSearchDocumentType,
    WikiSearchOrderType,
} from '~shared/models/wiki';

export interface SearchQueryParams {
    page: number;
    text: string;
    order: WikiSearchOrderType;
    authors?: WikiSearchAuthor[];
    documentType?: WikiSearchDocumentType;
    date?: SearchDateRange;
    showObsolete: boolean;
    slug?: string;
    fuzzy?: boolean;
}

export interface SearchDateRange extends DateFilter {
    range?: RangeType;
    type: SearchDateFilterType;
}

export type RangeType = 'day' | 'week' | 'month' | 'year';

export enum SearchDateFilterType {
    MODIFICATION = 'modification',
    CREATION = 'creation',
}
